var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-d-c-c shortcut-body"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"describe"},[_vm._v(_vm._s(_vm.describe))])])
}
var staticRenderFns = []

export { render, staticRenderFns }